/**
 * Site Admin Main Class
 *
 * @class siteadmin
 * @depends on jquery.actionController.js
 * @author Mihai Curelea
 *
 */

var $ = require('jquery');
var Modernizr = require('Modernizr');
var domUtils = require('diy/util/dom');
var Controller = require('diy/site-admin/main/controller');
var appsCatalog = require('diy/site-admin/apps-catalog/appsCatalog');
var api = require('./api');
var features = require('diy/util/features');

(function () {

    var self = this,
        $siteAdmin,
        $sidebar,
        $sidebarPlaceholder,
        animSpeed = 300, /* animation speed in Site Admin */
        sidebarActiveElem = null, /* reference to the active element in Site Admin */
        minimized = 0, /* whether the SiteAdmin bar is minimized */
        initialized = false, /* whether init was called and SiteAdmin is available */
        controller, /* reference to the site admin controller */
        params = null, /* params sent when opening a siteAdmin window */
        offsetMemory = null,
    //remember if we have an callout instance, so we don't call
    //methods or set options with no instance
        calloutInitFlag = false,
        controllers,
        activeControllerId,

        /** Was siteadmin window open when we collapsed the sidebar last time? */
        wasWindowOpenBeforeCollapse = false,

        initAccordion = function () {
            var expand = 'cc-sa-item-diy';

            $sidebar.find('#' + expand).addClass('cc-sa-open');
            $sidebar.find('>ul>li>a:not(#' + expand + ')').parent().find('>ul>li').hide();
        },

        buttonDisable = function (elementId, $element) {
            if (typeof $element !== "object") {
                $element = $sidebar.find('#' + elementId);
            }
            if ($element.size() > 0) {
                var $parent = $element.parent();
                $parent.addClass('cc-sa-disabled');
                $element.addClass('cc-sa-disabled').removeClass('cc-sa-active');
                $parent.children('div.eventBlocker').remove();
                $parent.append('<div class="eventBlocker" style="width:' + $parent.width() + 'px; height:' + $parent.height() + 'px;"></div>');
                return true;
            }
            return false;
        },

        buttonEnable = function (elementId, $element) {
            if (typeof $element !== "object") {
                $element = $sidebar.find('#' + elementId);
            }
            if ($element.size() > 0) {
                var $parent = $element.parent();
                $parent.removeClass('cc-sa-disabled');
                $parent.children('div.eventBlocker').remove();
                $element.removeClass('cc-sa-disabled');
                return true;
            }
            return false;
        };

    this.buttonDisable = buttonDisable;
    this.buttonEnable = buttonEnable;


    var expandGroup = function (el) {
        /* hide all children */
        $sidebar.find('>ul>li').find('>ul>li').hide();

        /* is the element we want to ensure is expanded a group or a button ? */
        var isGroup = $('#' + el.id).hasClass('cc-sa-sidebar-primary');

        /* if it is a group, ensure all his children are visible */
        if (isGroup) {

            /* as soon as you expand another group, the current window should close */
            if ($('#' + el.id).hasClass('noSiteAdminAction') && !$('#' + el.id).hasClass('cc-sa-open')) {
//                controller.close();
            }

            $sidebar.find('.cc-sa-sidebar-primary.cc-sa-open').removeClass('cc-sa-open');

            $sidebar.find('>ul>li>a#' + el.id).parent().find('>ul>li').show();
            $sidebar.find('#' + el.id).addClass('cc-sa-open');
        } else {
            /* when building the fbpb bar, the following line will be modified to support
             the desired facelift behavior */
            //$sidebar.find('.cc-sa-sidebar-primary.cc-sa-active').removeClass('cc-sa-active');
            $sidebar.find('>ul>li>ul>li>a#' + el.id).closest('ul').find('li').show();
        }
        $sidebar.find('>ul>li>ul>li>a.cc-sa-disabled').each(function () {
            buttonDisable(null, $(this));
        });
    };

    /**
     * checks if the window height is smaller/bigger than the sideadmin's height
     * and positions the siteadmin absolute or fixed
     * also triggers the diy-siteadmin-position-scheme-set in order for other
     * components (such as the simpleCallout) to be notified of the position changed
     */
    var lastScroll = $(window).scrollTop();
    var lastScrollIsDown = true;
    var checkPosition = function () {
        if (self._isHidden === true) {
            return;
        }

        var scrollTop = $(window).scrollTop();

        if (diy.editor.uiPreference.isPointerModeTouch()) {
            if (scrollTop < 0 || scrollTop >= document.documentElement.scrollHeight - window.innerHeight) {
                return;
            }
        }

        var scrollIsDown = null;
        var positionCSS = null;
        var currentPosition = $siteAdmin.css('position');

        //consider known top elements that push the site-admin down
        var considerOffset = diy.editor.positioning.calculateTopOffset();
        var winHeight = window.innerHeight;
        var siteAdminHeight = $siteAdmin.height();

        $('.diyw').css('min-height', siteAdminHeight + 'px');

        var lowestOffsetPosition = diy.editor.positioning.calculateLowestOffsetPosition();

        if ((winHeight - lowestOffsetPosition + scrollTop) < siteAdminHeight && scrollTop > 0) {
            positionCSS = {
                position: 'absolute',
                right: 'auto',
                left: $(window).width() + $(window).scrollLeft() - $sidebar.width(),
                top: considerOffset
            };

            // When page get refreshed with scroll, or siteadmin gets minimized / maximized
            // position the siteadmin with the top part visible, but beware not to get over bottom of the page
            if (scrollTop > 0) {
                if ($(document).height() - siteAdminHeight < scrollTop) {
                    positionCSS.top = $(document).height() - siteAdminHeight;
                } else {
                    positionCSS.top = lowestOffsetPosition;
                }

                if (arguments.length > 0 && arguments[0] instanceof jQuery.Event) {
                    var siteAdminTopOffset;
                    if (!/webkit.*mobile/i.test(navigator.userAgent)) {
                        siteAdminTopOffset = $siteAdmin.offset().top;
                    } else {
                        siteAdminTopOffset = diy.editor.positioning.calculateAbsoluteOffset($siteAdmin.get(0)).top;
                        if (domUtils.isFixedPosition($siteAdmin)) {
                            siteAdminTopOffset += window.scrollY;
                        }
                    }

                    if (scrollTop > lastScroll) {
                        scrollIsDown = true;
                    } else if (scrollTop < lastScroll) {
                        scrollIsDown = false;
                    } else {
                        scrollIsDown = lastScrollIsDown;
                    }
                    //Determines up-or-down scrolling
                    if (scrollIsDown) {
                        if (scrollTop + winHeight >= siteAdminHeight + siteAdminTopOffset) {
                            positionCSS.position = 'fixed';
                            positionCSS.right = '0';
                            positionCSS.left = 'auto';
                            //positionCSS.top = scrollTop + winHeight - siteAdminHeight;
                            positionCSS.top = winHeight - siteAdminHeight;
                        } else {
                            positionCSS.top = siteAdminTopOffset;
                        }
                    } else {
                        if (siteAdminTopOffset >= lowestOffsetPosition) {
                            positionCSS.position = 'fixed';
                            positionCSS.right = '0';
                            positionCSS.left = 'auto';
                            //positionCSS.top = lowestOffsetPosition;
                            positionCSS.top = lowestOffsetPosition - scrollTop;
                        } else {
                            positionCSS.top = siteAdminTopOffset;
                        }
                    }
                    if (scrollTop == lastScroll) {
                        return;
                    }
                    //Updates scroll position
                    lastScroll = scrollTop;
                    lastScrollIsDown = scrollIsDown;
                }
            }
        } else {
            //calculate the top
            var newPositionTop = diy.editor.positioning.calculateTopFixedOffset();

            positionCSS = {
                position: 'fixed',
                right: '0px',
                left: 'auto',
                top: newPositionTop
            };
        }
        $siteAdmin.css(positionCSS);

        /* Trigger an event telling the SiteAdmin bar
         has decided what position scheme to use.
         Will be useful to position stuff relative to it. */
        if (currentPosition !== positionCSS.position) {
            $siteAdmin.trigger('diy-siteadmin-position-scheme-set');
        }
    };

    /**
     * SiteAdmin init method,
     * gets called upon creating the global constructor
     */
    this.init = function () {

        controllers = {};

        /* instantiate the controller */
//        controller = new Controller();
//        controller.init();

        /* init site admin help button */
        try {
            cms.help.GuidedAssistant.getInstance()._initSiteAdminButton(cms.help.GuidedAssistant.options.siteAdminButtonId);
            cms.help.GuidedAssistant.getInstance()._initSiteAdminButtonByClass(cms.help.GuidedAssistant.options.modulesLinkClass);
        } catch (e) {
        }


        $('#cc-sa-item-privateTariffUpgrade').click(function (e){
            e.preventDefault();
            if (!features('upsellDirectLink')) {
                diy.editor.upgradeLayer.showUpgradeWindow();
            } else {
                diy.editor.upgradeLayer.openUpgradePopup();
            }
        });

        /* set the variables to their dom elements */
        $siteAdmin = $('#cc-sa');
        $sidebar = $('#cc-sa-sidebar');
        $sidebarPlaceholder = $('#cc-sa-sidebar-minimized');

        /* initializing the action controller */
        $siteAdmin.actionController(this, {history: true});

        /* which groups should be opened */
        initAccordion();

        /* show the siteadmin bar */
        $siteAdmin.show();

        /* load minimized status from the cookie */
        minimized = parseInt($.cookie('diy-siteadmin-sidebar-minimized'), 10) || 0;

        /* if is a device with touch (tablets or mobiles) we minimize the sitebar */
        if (diy.editor.uiPreference.isPointerModeTouch() && minimized !== 1) {
            minimized = 1;
        }

        if (minimized) {
            toggleSidebar(false, true);
        }

        /* if the window height is smaller than the siteadmin's
         height, then the siteadmin will scroll with the window */
        /*
         * Siteadmin-Fix for small resolutions:
         * If browser-height is less than siteadmin-height we will set it position:absolute
         * to ensure the option to close the siteadmin. Otherwise we will set it to position:fixed.
         */
        $(window).bind('resize', checkPosition);
        if (diy.editor.uiPreference.isPointerModeTouch()) {
            $(window).bind('scroll', $.throttle(300, checkPosition));
        } else {
            $(window).bind('scroll', checkPosition);
        }
        $(document).bind('diy-editor-toolbar-repositioned', checkPosition);
        setTimeout(checkPosition, 20);

        initialized = true;
        $siteAdmin.trigger('diy-siteadmin-initialized');

        /* Trigger an event telling the SiteAdmin bar
         has decided what position scheme to use.
         Will be useful to position stuff relative to it. */
        $siteAdmin.trigger('diy-siteadmin-position-scheme-set');

        /* listen for the active sidebar item event
         this event can be triggered to change the display state of a site admin button */
        $sidebar.bind("diy-siteadmin-active-sidebar-item", function (ev, itemId, setActive, resetCurrentActive) {
            self.toggleSidebarItem($sidebar.find("#" + itemId), setActive, resetCurrentActive);
        });

        /* what to do when a site admin window has been closed */
        $(document).bind('diy-siteadmin-window-closed', function (e, controller) {
            $(sidebarActiveElem).removeClass('cc-sa-active');
        });

        diy.editor.deeplinking.registerHandler(function (item) {
            var itemButton = $sidebar.find("#cc-sa-item-" + item);
            if (itemButton.length === 0) {
                throw new Error('Siteadmin item ' + item + 'not found');
            }
            itemButton.click();
        }, 'siteadmin');
    };

    this.isInitialized = function () {
        return initialized;
    };

    this.beforeSidebarItemClick = function (e, specificController) {
        var activeController = self.getController(),
            controllerName = null,
            allow = true,
            controller = null,
            newControllerName = specificController,
            newController = null;

        Modul.abortEditingModules();

        //get from the current controller if it allows the switch
        if (activeController) {
            controllerName = activeController.getControllerName();
        }

        //if the prev controller allows swithcing away
        if (controllerName) {
            controller = diy.editor.siteadmin.controllers[controllerName];
            if (controller &&
                controller.hasOwnProperty('allowSwitch')
            ) {
                allow = controller.allowSwitch();
            }
        }

        //if the new controller allows opening
        if (allow === true) {
            newController = diy.editor.siteadmin.controllers[newControllerName];
            if (newController &&
                newController.hasOwnProperty('allowOpen')
            ) {
                allow = newController.allowOpen();
            }
        }
        return allow;

    };

    this.getMinMaxState = function () {
        var state = 'max',
            currentllyOpenedController = self.getController();
        if (currentllyOpenedController) {
            state = currentllyOpenedController.getMinMaxState();
        }
        return state;
    };

    /*
     * Display the navigation right after the siteadmin content is loaded. This is necessary because on the sidebarItemClick()
     * call we hide the navigation, title and description of the current loaded window in order to prevent displaying
     * the previous window header information while the new content is being loaded. So, when the client opens a new
     * window we hide the previous opened window metadata: title, description and navigation. The new metadata is
     * currently available only after the content is fully loaded so this is why we have to bind to the
     * "diy-siteadmin-content-loaded" event.
     *
     * @see: DHDIYED-265
     */
//    $(document).bind('diy-siteadmin-content-loaded', function(){
//        controller.showNavi();
//    });

    /**
     * Action taken when a click is performed on a SiteAdmin item
     *
     * @param {Event} e the event received
     * @param {string} controller the name of the controller
     * @param {object} params send params to the site admin section that will open
     */
    this.sidebarItemClick = function (e, specificController, params) {
        if ($(this).hasClass('cc-sa-active')) {
            return false;
        }

        var currentlyOpenController = self.getController();
        if (currentlyOpenController && currentlyOpenController.isOpened()) {
            currentlyOpenController.close(true);
        }


        /*
         * Hide the navigation, title and description of the current loaded window so that it won't
         * be visible until the new content has been loaded; When the new content is loaded the new [navigation], title and
         * description will be rendered.
         *
         * @see: DHDIYED-265
         */
//        controller.hideNavi();
//        controller.updateTitle('');
//        controller.updateDescr('');

        /* track that the sidebar item has been clicked */
        $(document).trigger('diy-editor-generic-sectionAccessed', {
            sectionCodeName: $(this).attr('id').replace('cc-sa-item-', ''),
            trackingParams: params
        });
        /* save the timestamp for other tracking points */
        $(document).trigger('diy-editor-saveUserClickTimestamp', {
            sectionCodeName: $(this).attr('id').replace('cc-sa-item-', '')
        });

        $(document).trigger('diy-editor-siteadmin-sectionOpened');

        /* make sure the group of the item or the group itself is expanded */
        expandGroup(this);

        var isGroup = $(this).hasClass('cc-sa-sidebar-primary');
        if (isGroup) {
            $sidebar.find(".cc-sa-sidebar-primary").removeClass('cc-sa-active');
            $(this).addClass('cc-sa-active');
            $(document).trigger('diy-siteadmin-window-closed');
            if (activeControllerId && controllers[activeControllerId]) {
                controllers[activeControllerId].close();
            }
        }

        /* if the action should not be handled by SiteAdmin controller */
        if ($(this).hasClass('noSiteAdminAction')) {
            if (! $(this).hasClass('noActiveState')) {
                $(this).addClass('cc-sa-active');
            }
            return false;
        }

        /* set any params sent when opening the window */
        self.setParams(params);

        if (specificController === 'appsCatalog') {
            if ($(this).data('customHref') || params) {
                self.destroyController('cc-sa-item-appscatalog');
            }
        }

        if (specificController === 'sectionSelector') {
            self.destroyController('cc-sa-item-sections');
        }

        if (!controllers[$(this).attr('id')]) {
            if (specificController === 'appsCatalog') {
                /* when call made with actual event*/
                if ($.isPlainObject(e)) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
                var url = $(this).attr('href');
                var customUrl = $(this).data('customHref');
                $(this).data('customHref', null);
                if (customUrl) {
                    url = customUrl;
                }
                if (url) {
                    appsCatalog.open(url, false);
                }
            } else {

                activeControllerId = $(this).attr('id');

                controllers[activeControllerId] = new Controller();
                controllers[activeControllerId].init();

                /* set window behavior and content type */
                controllers[activeControllerId].load({
                    element: this,
                    controller: specificController,
                    windowBehavior: $(this).attr('data-window-behavior'),
                    contentType: $(this).attr('data-content-type'),
                    originalWindowBehavior: $(this).attr('data-window-behavior')
                });

                /* show the controller */
                controllers[activeControllerId].show();

            }
        } else {
            activeControllerId = $(this).attr('id');
            /* show the controller */
            controllers[activeControllerId].show(true);

        }

        /* make the SiteAdmin item look active */
        self.setSidebarActiveItem(this);

        if (minimized) {
            toggleSidebar(true, true);
        }

        return false;
    };

    /**
     * Slide the SiteAdmin up
     */
    this.sidebarSlideUpClick = function () {
        toggleSidebar(false);
        return false;
    };

    /**
     * Slide the SiteAdmin down
     */
    this.sidebarSlideDownClick = function () {
        toggleSidebar(true);
        return false;
    };

    /**
     * Show the window and eventually load a src
     *
     */
    this.showWindow = function (src, windowBehavior, contentType, customController, controllerId) {
        activeControllerId = controllerId;

        if (!controllers[activeControllerId]) {
            controllers[activeControllerId] = new Controller();
            controllers[activeControllerId].init();

            /* load the controller */
            controllers[activeControllerId].load({
                element: {
                    href: src
                },
                controller: customController || null,
                windowBehavior: windowBehavior || $(this).attr('data-window-behavior'),
                contentType: contentType || $(this).attr('data-content-type'),
                originalWindowBehavior: $(this).attr('data-window-behavior')
            });
            controllers[activeControllerId].show();
        } else {
            /* shows the window */
            controllers[activeControllerId].show(true);
        }

        /* set active Site Admin item */
        self.setSidebarActiveItem(sidebarActiveElem);

        /* if the Site Admin is minimized, show the Site Admin */
        if (minimized) {
            toggleSidebar(true, true);
        }
    };

    /**
     * Sets the current Site Admin item
     *
     * @param elem the element
     */
    this.setSidebarActiveItem = function (elem) {
        /* window must be opened and element must exist */
        if (!controllers[activeControllerId].isOpened() || !elem) {
            return;
        }

        /* remove active class from the active element */
        $(sidebarActiveElem).removeClass('cc-sa-active');

        /* remove any styles added to pointer elements */
        $(sidebarActiveElem).find('.cc-sa-sidebar-selected-pointer').attr('style', '');

        /* set the current Site Admin element */
        sidebarActiveElem = elem;

        /* make it active */
        $(elem).addClass('cc-sa-active');

        /* update the id made active and */
        api.updateID(elem.id);
    };

    /**
     * Toggles a Site Admin item
     *
     * @param $elem the element it should toggle
     * @param setActive whether to set it active
     * @param resetCurrentActive whether it should reset the current active one
     */
    this.toggleSidebarItem = function ($elem, setActive, resetCurrentActive) {
        if (setActive) {
            if (resetCurrentActive) {
                $(sidebarActiveElem).removeClass('cc-sa-active');
                sidebarActiveElem = elem;
            }
            $elem.addClass('cc-sa-active');
        } else {
            $elem.removeClass('cc-sa-active');
        }
    };

    /**
     * Toggle Site Admin
     *
     * @param {boolean} show whether should be shown
     * @param {boolean} noAnimation whether should use animation or not
     */
    function toggleSidebar(show, noAnimation) {
        if ($sidebar.is(":visible") === !!show) {
            return false;
        }

        var activeController = self.getController();
        var siteAdminWindow = activeController ? activeController.getWindow() : null;
        if (!show && noAnimation) {
            $sidebar.hide();
            if (siteAdminWindow) {
                wasWindowOpenBeforeCollapse = siteAdminWindow.isOpened();
                siteAdminWindow.hide();
            }
            if (diy.editor.uiPreference.isPointerModeTouch()) {
                $('#cc-sa-sidebar-header').addClass('toggledOff');
            }
            $sidebarPlaceholder.show();
            ready();
            checkPosition();
        } else if (show) {
            if (diy.editor.uiPreference.isPointerModeTouch()) {
                $('#cc-sa-sidebar-header').removeClass('toggledOff');
            }
            $sidebarPlaceholder.slideUp(animSpeed, function () {
                $sidebar.slideDown(animSpeed, function () {
                    ready();
                    checkPosition();
                });
                if (wasWindowOpenBeforeCollapse) {
                    siteAdminWindow && siteAdminWindow.show();
                }
            });
        } else if (!show) {
            wasWindowOpenBeforeCollapse = siteAdminWindow && siteAdminWindow.isOpened();
            ready();
            $sidebar.slideUp(animSpeed, function () {
                if (diy.editor.uiPreference.isPointerModeTouch()) {
                    $('#cc-sa-sidebar-header').addClass('toggledOff');
                }

                $sidebarPlaceholder.slideDown(animSpeed, function () {
                    checkPosition();
                });
            });
            siteAdminWindow && siteAdminWindow.hide();
        }

        function ready() {
            $(document).trigger('diy-siteadmin-sidebar-toggled', [show, noAnimation]);
            minimized = show ? 0 : 1;
            $.cookie('diy-siteadmin-sidebar-minimized', minimized, {
                expires: 300,
                path: '/'
            });
            $('#cc-sa-sidebar-header').css('cursor', show ? 'auto' : 'pointer');
        }
    }

    this.toggleSidebar = toggleSidebar;

    this.hide = function() {
      // this flag is used to disable
      // resposition on window scroll/resize (see checkPosition)
      self._isHidden = true;
      $('#cc-sa').addClass('is-hidden is-transition-enabled');
    };

    this.show = function() {
      var $sa = $('#cc-sa');
      $sa.removeClass('is-hidden');
      setTimeout(function() {
        $sa.removeClass('is-transition-enabled');
        self._isHidden = false;
        checkPosition();
      }, 300); // the same as `transition-duration`
    };

    this.isSidebarMinimized = function () {
        return minimized ? true : false;
    };

    this.getSidebarContainer = function () {
        return $sidebar;
    };

    this.getSidebarActiveElem = function () {
        return sidebarActiveElem;
    };

    this.destroyController = function (controllerId, withClose) {
        if (controllers[controllerId]) {
            if (withClose === true) {
                controllers[controllerId].close(true, true);
            }
            controllers[controllerId].destroy();
            delete controllers[controllerId];
        }
    };

    this.getActiveControllerId = function () {
        return activeControllerId;
    };

    this.getController = function (controllerId) {

        if ('string' === typeof controllerId) {
            if ('object' === typeof controllers && 'object' === typeof controllers[controllerId]) {
                return controllers[controllerId];
            }
        } else if ('string' === typeof activeControllerId) {
            if ('object' === typeof controllers && 'object' === typeof controllers[activeControllerId]) {
                return controllers[activeControllerId];
            }
        }
        return null;
    };
    /**
     * this is mainly dictated by: cms_Element_TemplateBuilderCMS::newFeatureProperties()
     */
    this.activateNewFeatureCallout = function () {
        //this time showing the callout for layouts
        var calloutData = {
            cls: 'wt-reinvoke-callout', //used in the past: 'diy-simple-callout-apps-catalog', 'module-selector-callout', 'wt-reinvoke-callout'
            featureId: jimdoData.newFeatureCallout.featureId,
            hideDelay: 20000, //NOTE: autohide also disables it
            hideLeftButton: true,
            hideRightButton: true,
            text: {
                title: jimdoData.messages.newFeatureCallout.title,
                content: jimdoData.messages.newFeatureCallout.content
            }
        };
        var saId = jimdoData.newFeatureCallout.siteAdminId;
        this.activateCallout(saId, calloutData);
        //never show callout again (user can refresh in the 20 seconds period)
        this.disableCalloutFeature(jimdoData.newFeatureCallout.featureId);
    };

    this.closeCallout = function (elementId) {
        if (!this.isInitialized()) {
            $(document).one('diy-siteadmin-initialized', '#cc-sa', function () {
                self.closeCallout(elementId);
            });
            return;
        }
        var $target = $('#' + elementId).first();
        if (!$target.length) {
            return;
        }

        if (!$target.is(':diy-simpleCallout')) {
            return
        }
        if (calloutInitFlag == true) {
            $target.diy_simpleCallout('close');
        }
    };

    this.activateCallout = function (elementId, calloutData) {
        if (!this.isInitialized()) {
            $(document).one('diy-siteadmin-initialized', '#cc-sa', function () {
                self.activateCallout(elementId, calloutData);
            });
            return;
        }

        var $target = $('#' + elementId).first();
        if (!$target.length) {
            return;
        }

        if (!$target.is(':diy-simpleCallout')) {
            _initCallout($target, calloutData);
        }

        showCallout($target);
    };

    /**
     * returns object type variable representing parameters sent when opening the SA window
     * @return {Object|null}
     */
    this.getParams = function () {
        return this.params;
    };

    /**
     * @param object params sent when opening a siteadmin window
     * @example when we try to open layout selector window to the recommended tab
     */
    this.setParams = function (params) {
        if (jQuery.isPlainObject(params)) {
            this.params = params;
        } else {
            this.params = null;
        }
    };

    var disableCalloutFeature = function (featureId) {
        $.ajax({
            url: '/app/help/service/disable-sidebar-callout/?id=' + featureId
        });
    };

    this.disableCalloutFeature = disableCalloutFeature;

    var showCallout = function ($target) {
        if (!calloutInitFlag) {
            return;
        }
        $target.diy_simpleCallout('show');
    };

    var hideCallout = function ($target) {
        if (!calloutInitFlag) {
            return;
        }
        $target.diy_simpleCallout('hide');
    };

    var _initCallout = function ($target, calloutData) {

        var refreshPosition = function () {
            if (calloutInitFlag == true) {
                $target.diy_simpleCallout('option', 'positionMode',
                    $siteAdmin.css('position') == 'fixed' ? 'fixed' : 'absolute');
            }
        };

        // code to run when the callback is disabled //
        var disableCallout = function () {
            if (!calloutInitFlag) {
                return;
            }

            if (calloutData.featureId) {
                disableCalloutFeature(calloutData.featureId);
            }
            $target.diy_simpleCallout('destroy');
            calloutInitFlag = false;
            jQuery(document).unbind('.diy-simple-callout');
            $siteAdmin.unbind('diy-siteadmin-position-scheme-set', refreshPosition);
        };

        // add the callout to the page //
        var calloutSettings = {
            positionMode: calloutData.positionMode ? calloutData.positionMode :
                ($siteAdmin.css('position') == 'fixed' ? 'fixed' : 'absolute'),
            anchor: calloutData.anchor ? calloutData.anchor : 'left',
            cls: calloutData.cls || null,
            zIndex: calloutData.zIndex > 0 ? calloutData.zIndex : 100100, // this is the same z-index like the Side Bar

            title: calloutData.text.title,
            content: calloutData.text.content,
            close: $.isFunction(calloutData.close) ? function () {
                calloutData.close();
                disableCallout();
            } : disableCallout,
            show: $.isFunction(calloutData.show) ? calloutData.show : null,
            footer: !(calloutData.hideLeftButton && calloutData.hideRightButton),
            triggerMode: calloutData.triggerMode,
            buttons: {
                left: !calloutData.hideLeftButton && {
                    text: calloutData.text.close,
                    handler: disableCallout
                },
                right: !calloutData.hideRightButton && {
                    text: calloutData.text.show,
                    handler: function () {
                        disableCallout();
                        if (typeof calloutData.callback == "function") {
                            calloutData.callback.call();
                        } else {
                            $target.click();
                        }
                    }
                }
            }
        };
        if (calloutData.triggerMode) {
            calloutSettings.triggerMode = calloutData.triggerMode;
        }

        if (calloutData.fadeInDelay) {
            calloutSettings.fadeInDelay = calloutData.fadeInDelay;
        }

        $target.diy_simpleCallout(calloutSettings);
        calloutInitFlag = true;

        if (calloutData.hideDelay) {
            setTimeout(disableCallout, calloutData.hideDelay);
        }

        $siteAdmin.bind('diy-siteadmin-position-scheme-set', refreshPosition);

        // register a handler for when clicking on menu items //
        $('div#cc-sa div#cc-sa-sidebar a[data-action=sidebarItem]')
            .bind('click.diy-simple-callout', function () {

                // the specified item is clicked //
                if (this == $target[0]) {
                    disableCallout($target, calloutData);
                    // something else is clicked //
                } else {
                    if ($(this).attr('id') == "cc-sa-item-assistant") {
                        return;
                    }

                    hideCallout($target);
                }
            });

        // register handlers for when minimizing and maximizing the SA side bar //
        $('div#cc-sa *[data-action=sidebarSlideUp]').click(function () {
            hideCallout($target);
        });
        $('div#cc-sa *[data-action=sidebarSlideDown]').click(function () {
            // allow for animation //
            setTimeout(function () {
                // the SA bar can open back the window in some situations//
                if (!$('div#cc-sa div.sa-window').is(':visible')) {
                    showCallout($target);
                }
            }, 1000);
        });

        // register a handler for when closing the SA //
        $(document).bind('diy-siteadmin-window-closed.diy-simple-callout', function () {
            showCallout($target);
        });
    };

    return this;

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/site-admin/main/siteadmin.js
 ** module id = 20
 ** module chunks = 0
 **/